module.exports = __webpack_public_path__ + "static/media/janirococcus.d830fdf4.png";